var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row d-lg-none swiper-1row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "accessories-swiper-container" }, [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.accessories, function (accessory, indexAccessory) {
              return _c(
                "div",
                {
                  key: accessory.defaultVersion.idSeo.value,
                  staticClass: "swiper-slide",
                },
                [
                  _c("AccessoryCard", {
                    attrs: {
                      id: "accessory-card-" + indexAccessory,
                      accessory: accessory,
                      "das-dto": _vm.dasDto,
                      "open-card-button-label": _vm.openCardButtonLabel,
                      "advantage-messages": _vm.advantageMessages,
                      "compact-promo-messages-dto": _vm.compactPromoMessagesDto,
                      "accessory-ctrl": _vm.accessoryCtrl,
                    },
                    on: {
                      "accessory-updated": _vm.onUpdate,
                      "accessory-error": _vm.onError,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-none d-lg-block d-xl-block d-xxl-none grid-3col" },
      [
        _vm._l(_vm.numberOfRows(3), function (y) {
          return _c(
            "div",
            { key: "desktop-3-card-y-" + y, staticClass: "row" },
            _vm._l(3, function (x) {
              return _c(
                "div",
                { key: "desktop-3-card-x-" + x, staticClass: "col-4" },
                [
                  _vm.index(x, y, 3) < _vm.maxNumberOfVisibleAccessories(3)
                    ? _c("AccessoryCard", {
                        staticClass: "mb-2",
                        attrs: {
                          id:
                            "accessory-card-" +
                            _vm.index(x, y, 3) +
                            "-grid-3col",
                          accessory: _vm.accessories[_vm.index(x, y, 3)],
                          "das-dto": _vm.dasDto,
                          "open-card-button-label": _vm.openCardButtonLabel,
                          "advantage-messages": _vm.advantageMessages,
                          "compact-promo-messages-dto":
                            _vm.compactPromoMessagesDto,
                          "accessory-ctrl": _vm.accessoryCtrl,
                        },
                        on: {
                          "accessory-updated": _vm.onUpdate,
                          "accessory-error": _vm.onError,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 d-flex justify-content-center" }, [
            _vm.visibleRowsCount < _vm.numberOfRows(3)
              ? _c(
                  "button",
                  {
                    staticClass: "ob1-link-arrow",
                    attrs: { "aria-expanded": "false" },
                    on: { click: _vm.onMoreAccessoryButtonClickCol3 },
                  },
                  [
                    _vm._v(
                      "\n                    Voir plus d’accessoires\n                "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-none d-xxl-block grid-4col" },
      [
        _vm._l(_vm.numberOfRows(4), function (y) {
          return _c(
            "div",
            { key: "desktop-4-card-y-" + y, staticClass: "row" },
            _vm._l(4, function (x) {
              return _c(
                "div",
                { key: "desktop-4-card-x-" + x, staticClass: "col-3" },
                [
                  _vm.index(x, y, 4) < _vm.maxNumberOfVisibleAccessories(4)
                    ? _c("AccessoryCard", {
                        staticClass: "mb-2",
                        attrs: {
                          id:
                            "accessory-card-" +
                            _vm.index(x, y, 4) +
                            "-grid-4col",
                          accessory: _vm.accessories[_vm.index(x, y, 4)],
                          "das-dto": _vm.dasDto,
                          "open-card-button-label": _vm.openCardButtonLabel,
                          "advantage-messages": _vm.advantageMessages,
                          "compact-promo-messages-dto":
                            _vm.compactPromoMessagesDto,
                          "accessory-ctrl": _vm.accessoryCtrl,
                        },
                        on: {
                          "accessory-updated": _vm.onUpdate,
                          "accessory-error": _vm.onError,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 d-flex justify-content-center" }, [
            _vm.visibleRowsCount < _vm.numberOfRows(4)
              ? _c(
                  "button",
                  {
                    staticClass: "ob1-link-arrow",
                    attrs: { "aria-expanded": "false" },
                    on: { click: _vm.onMoreAccessoryButtonClickCol4 },
                  },
                  [
                    _vm._v(
                      "\n                    Voir plus d’accessoires\n                "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }